<template>
    <div v-if="title || content" class="section-heading text-white">
        <h1 v-if="title" class="xl:text-5xl lg:text-5xl text-5xl md:text-size8 xl:leading-spc3 lg:leading-spc3 leading-spc3 md:leading-spc9 mb-spc3">
            {{title}}
        </h1>
        <p v-if="content" class="text-size2 leading-spc4 opacity-80" :class="contentclass">
            {{content}}
        </p>
    </div>
</template>

<script>
    export default {
        name: "SectionHeading",
        props: ['title', 'content', 'contentclass']
    }
</script>

<style scoped>

</style>